import { Expose, Transform } from 'class-transformer';
import { DrupalIdentifier, DrupalNode } from '@nx-icilalune/drupal-types';

export interface Address {
  address_line1: string;
  address_line2: string;
  country_code: string;
  langcode: string;
  locality: string;
  postal_code: string;
}

export class Agency extends DrupalNode {
  public static readonly type = 'agencies';

  @Transform(({ obj }) => {
    return obj?.attributes?.adresse;
  })
  @Expose()
  address!: Address;

  @Transform(({ obj }) => {
    const rawProfiles: any[] =
      obj?.relationships?.associated_profiles?.data?.filter(
        (d: any) => !!d && d.id !== 'missing'
      );
    if (rawProfiles) {
      return rawProfiles;
    }
    return undefined;
  })
  @Expose()
  profiles?: DrupalIdentifier[] | undefined;

  @Transform(({ obj }) => {
    const geoLoc = obj?.attributes?.coordonnee_gps;
    if (geoLoc) {
      return { lon: geoLoc.lon, lat: geoLoc.lat };
    }
    return undefined;
  })
  @Expose()
  geoLoc!: { lon: number; lat: number } | undefined;
}
